<template>
  <transition :duration="300">
    <div v-if="updateFields_Len > 0" class="TicketFormOperationBar">
        <template v-if="spanShow">
          <div v-for="(v,k) in updateFields" :key="k" style="margin:0 10px 0 10px;font-size:50%;">
            <span>{{v.fieldLabel}} : </span>

            <el-popover trigger="hover"
              placement="top"
              width="950">
              <span v-html="parsedFieldValueBefore(v)" />
              <span slot="reference">{{parsedFieldValueBefore(v) | ellipsis_50 }}</span>
            </el-popover>

            <span> > </span>

            <el-popover trigger="hover"
              placement="top"
              width="950">
              <span v-html="parsedFieldValue(v)" />
              <span slot="reference">{{parsedFieldValue(v) | ellipsis_50}}</span>
            </el-popover>
          </div>
        </template>

        <el-button @click="updateTicketFormField" title="点击提交修改" type="primary">提交修改</el-button>
        <el-button @click="doCancel" title="点击取消">取消</el-button>
    </div>
  </transition>
</template>

<script>
export default {
  name: "TicketFormOperationBar",

  data() {
      return {
          updateFields_Len : 0,
          updateFields : {},
          spanShow : true
      };
  },

  methods : {
    doCancel() {
      this.updateFields = {};
      this.updateFields_Len = 0;
    },

    updateTicketFormField() {
      if ( !confirm('确定要修改这些内容?') ) {
        return;
      }

      var _this = this;

      for ( var _key in _this.updateFields ) {
        var _each = _this.updateFields[_key];

        var _operateContent = "修改了表单 " + _each.fieldLabel + "(" + _each.fieldName + ") 的值 " //
          + _this.parsedFieldValueBefore( _each ) + " > " + _this.parsedFieldValue( _each );

        sdk.TicketWorkflowApi().updateTicketFormField(Object.assign({
          operateContent : _operateContent
        }, _each)).then((res, _req) => {
            _message('修改 ' + _req.args[0].fieldLabel + ' 成功');

            _this.$emit('submit', null);
        }, err => {
          _alert('修改表单失败 ' + err);
        });
      }

      this.updateFields = {};
      this.updateFields_Len = 0;
    },

    onTicketTaskFormChange( _e ) {
      var _key = _e.ticketNo + ":" + _e.taskId + ":" + _e.fieldName;

      this.updateFields[_key] = _e;

      this.updateFields_Len = Object.keys(this.updateFields).length;
      this.spanShow = false;
      this.spanShow = true;
    }
  }
};
</script>

<style>
.TicketFormOperationBar {
  min-height: 45px;
  width: 60vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  position: fixed;
  bottom: 0;
  box-shadow: 0 -1px 3px rgba(0,0,0,.15);
  background: #efefefcc;
  padding:0 10px 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormOperationBar.vue